import { HierarchyContextProps, IHierarchyActionUpdateSingleReplacement } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Updates a single replacement in the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-single-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_updateSingleReplacements = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateSingleReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const ix = state.hierarchy.singles.findIndex((s) => s.airid === action.single.airid);
  if (ix > -1) {
    return hcr_updateChangedFlag(
      {
        ...state,
        hierarchy: {
          ...state.hierarchy,
          singles: state.hierarchy.singles.map((s) =>
            s.airid === action.single.airid ? action.single : s,
          ),
        },
      },
      action,
    );
  }

  return state;
};
